import { render, staticRenderFns } from "./ShortReport.vue?vue&type=template&id=85be0f14&scoped=true"
import script from "./ShortReport.vue?vue&type=script&lang=js"
export * from "./ShortReport.vue?vue&type=script&lang=js"
import style0 from "./ShortReport.vue?vue&type=style&index=0&id=85be0f14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85be0f14",
  null
  
)

export default component.exports